module.exports = __webpack_public_path__ + "img/julia-dominguez-perrone.0e8f54ab.jpg";